<template>
    <div>
        <!--begin: mobile header -->
        <a class="hide-lg position-absolute left-0 py-2 px-5" href="#" style="top: 20px;">
            <img alt="media_logo" src="/media/logos/externalis_blue_half.png" width="80"/>
        </a>
        <!--end: mobile header -->

        <!--begin::Signin-->
        <div class="login-form login-signin">
            <div class="text-center mb-10 pb-5">
                <div class="auth_signIn_heading pb-3">Welcome Back!</div>
                <div class="auth_signIn_subheading">Sign in to your account</div>
            </div>

            <p class="error" v-if="swap.error_message">
                {{ swap.error_message }}
            </p>

            <button @click="authWithGoogle" class="auth_socialmedia_btn mb-5" ref="auth_google_btn">
                <div>
                    <img alt="media_google" class="float-left" src="/media/logos/google_logo.png" width="20"/>
                    <span class="position-absolute right-0 left-0">Sign in with Google</span>
                </div>
            </button>
            <button @click="authWithFacebook" class="auth_socialmedia_btn" ref="auth_facebook_btn">
                <div>
                    <img alt="media_facebook" class="float-left" src="/media/logos/facebook_logo.png" width="20"/>
                    <span class=" position-absolute right-0" style="left:15px;">Sign in with Facebook</span>
                </div>
            </button>

            <div class="auth_note pb-10 mb-10">
                Click “Sign In” to agree to Externalis
                <a class="ln" href="">Terms of Service</a>
                and acknowledge that Externalis <a class="ln" href="">Privacy Policy</a> applies to you.
            </div>
            <div class="text-center">
                <img alt="media_playstore" class="mr-4" src="/media/logos/playstore.png" width="120"/>
                <img alt="media_apple_store" src="/media/logos/apple_store.png" width="120"/>
            </div>
        </div>
        <!--end::Signin-->
    </div>
</template>


<script>

   import {mapGetters} from "vuex";
   import generalMixin from '../../../core/mixins/generalMixin';
   import {SIGNIN_WITH_GOOGLE, SIGNIN_WITH_FACEBOOK} from "@/core/store/modules/auth";

   export default {
      name: "login",
      data() {
         return {
            swap: {
               error_message: '',
            }
         };
      },
      mixins: [generalMixin],
      methods: {
         authWithGoogle() {
            this.resetErrorMessage();
            this.$store.dispatch(SIGNIN_WITH_GOOGLE);
         },
         authWithFacebook() {
            this.resetErrorMessage();
            this.$store.dispatch(SIGNIN_WITH_FACEBOOK)
         },
         resetErrorMessage() {
            this.swap.error_message = '';
         }
      },
      computed: {
         ...mapGetters([
            'user',
            'isAuth',
            'errors'
         ])
      },
      watch: {
         'isAuth'() {

            if(this.user.providerId === 'facebook') {
               // set spinner to submit button
               const submitButton = this.$refs["auth_facebook_btn"];
               this.addSpinner(submitButton);
            } else {
               // set spinner to submit button
               const submitButton = this.$refs["auth_google_btn"];
               this.addSpinner(submitButton);
            }

            // dummy delay
            setTimeout(() => {
               this.$router.push({name: 'create_report'});
            }, 2000);
         },
         'errors'(err) {
            if(err) {
               this.swap.error_message = (err.message ? err.message : 'Unable to login, please try again or use different authentication method');
               console.log('err', err);
            }
         }
      }
   };
</script>


<style lang="scss" scoped>
    .error {
        color: red;
        font-size: 12px;
        padding-top: 3px;
        text-align: center;
    }
</style>
